import { reportSentryError } from '../sentry';
export const ErrorMixin = (superClass) => {
    class ErrorMixinClass extends superClass {
        connectedCallback() {
            try {
                super.connectedCallback();
            }
            catch (error) {
                reportSentryError(error);
            }
        }
        disconnectedCallback() {
            try {
                super.disconnectedCallback();
            }
            catch (error) {
                reportSentryError(error);
            }
        }
        performUpdate() {
            try {
                super.performUpdate();
            }
            catch (error) {
                reportSentryError(error);
            }
        }
    }
    return ErrorMixinClass;
};
